import { PermissionClient } from '../api/clients/permission.client';
import { Injectable } from '@angular/core';
import { PermissionsOverResources } from '@app-types/api/permissions';
import { PermissionType } from '@app-types/enums/permission-type';
import { environment } from 'src/environments/environment';
import { STORAGE_NAMES } from '@app-shared/constants/constants';

const { SHOW_ADVANCED_SETTINGS } = STORAGE_NAMES;

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private permissionsOverResources$: PermissionsOverResources;
  private showAdvancedSettings = !!localStorage.getItem(SHOW_ADVANCED_SETTINGS);

  constructor(private permissionClient: PermissionClient) {}

  private async fetchPermissionsOverResources(): Promise<PermissionsOverResources> {
    return await this.permissionClient.get();
  }

  private async getPermissionsOverResources(): Promise<PermissionsOverResources> {
    if (!this.permissionsOverResources$) {
      this.permissionsOverResources$ =
        await this.fetchPermissionsOverResources();
    }
    return this.permissionsOverResources$;
  }

  public async hasPermissionOver(
    organizationId: number | null,
    mailAccountId: number | null,
    requiredPermission: PermissionType
  ): Promise<boolean> {
    const permissions: PermissionsOverResources =
      await this.getPermissionsOverResources();

    if (permissions.isRoot) {
      return true;
    }

    if (mailAccountId) {
      return (
        permissions.mailAccountPermissions[+mailAccountId]?.some(
          (p: PermissionType) => p === requiredPermission
        ) ?? false
      );
    }

    if (organizationId) {
      return (
        permissions.organizationPermissions[+organizationId]?.some(
          (p: PermissionType) => p === requiredPermission
        ) ?? false
      );
    }

    return false;
  }

  public async hasPermissionInMailAccounts(
    requiredPermission: PermissionType
  ): Promise<boolean> {
    const permissions: PermissionsOverResources =
      await this.getPermissionsOverResources();

    return (
      Object.values(permissions.mailAccountPermissions ?? {})?.some(
        (p: PermissionType[]) => p.includes(requiredPermission)
      ) ?? false
    );
  }

  public hasPermissionToSeeUserByUserEmail(email: string): boolean {
    if (this.showAdvancedSettings) {
      return true;
    } else {
      return !environment.systemUsers.includes(email);
    }
  }
}
